import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navigation from "@/components/site/Navigation";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import MeatApp from "@/pages/MeatApp";
import SheepInvest from "@/pages/SheepInvest";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App bg-bone text-ink" data-testid="app-root">
      <BrowserRouter>
        <ScrollToTop />
        <Navigation />
        <main data-testid="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products/livecuts" element={<MeatApp />} />
            <Route path="/products/freshcut" element={<MeatApp />} />
            <Route path="/products/flockfolio" element={<SheepInvest />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <Toaster
          position="bottom-right"
          toastOptions={{
            classNames: {
              toast:
                "border border-bone-300 bg-white text-ink font-sans rounded-none shadow-none",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
